// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========================================================================
   Project — 프로젝트 영역
   사이드바·인트로·필터 공통 스타일은 Prompt.css / Agent.css 재사용
   ======================================================================== */

/* ───────── 사이드바 ───────── */
.project__sidebar {
  display: flex;
  flex-direction: column;
}

.project__sidebar-new {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 12px;
  background: var(--fg-bg-mychat, #e5e7f3);
  border: 0;
  border-radius: 12px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  color: var(--fg-text-basic, #3b3b3b);
  cursor: pointer;
  text-align: left;
  transition: var(--transition-fast, all 0.15s ease);
}

.project__sidebar-new:hover {
  background: var(--fg-bg-liteblue, #f6f8ff);
}

.project__sidebar-new > svg {
  flex-shrink: 0;
  color: var(--fg-text-basic, #3b3b3b);
}

.project__sidebar-projects {
  list-style: none;
  margin: 8px 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.project__sidebar-project {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 10px 10px 14px;
  background: #fff;
  border: 1px solid #fff;
  border-radius: 12px;
  cursor: pointer;
  transition: var(--transition-fast, all 0.15s ease);
}

.project__sidebar-project:hover {
  background: #fff7f0;
  border-color: #ffcfa8;
}

.project__sidebar-project--active,
.project__sidebar-project--active:hover {
  background: #fff7f0;
  border-color: #ff7700;
}

.project__sidebar-project-icon {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  color: #ff7700;
}

.project__sidebar-project-title {
  flex: 1 1;
  min-width: 0;
  padding-top: 4px;
  font-size: 15px;
  font-weight: 500;
  color: #464646;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.project__sidebar-project-actions {
  display: inline-flex;
  align-items: center;
  gap: 2px;
}

.project__sidebar-project-btn {
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  border-radius: 6px;
  color: var(--fg-text-gray, #838383);
  cursor: pointer;
}

.project__sidebar-project-btn:hover {
  background: rgba(0, 0, 0, 0.04);
  color: var(--fg-text-basic, #3b3b3b);
}

/* 사이드바 대화 항목은 LLM 실습 사이드바(.llm__chat-*) 디자인을 그대로 사용 */

/* ───────── ProjectList — 생성하기 버튼 행 ───────── */
.project-list__create-row {
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
  margin-bottom: 12px;
}

/* ───────── ProjectList — 카드 그리드/리스트 ───────── */
.project-list__cards {
  margin-top: 16px;
  display: grid;
  gap: 16px;
}

.project-list__cards--grid {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.project-list__cards--list {
  grid-template-columns: 1fr;
}

@media (max-width: 1280px) {
  .project-list__cards--grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

/* ───────── 프로젝트 카드 ───────── */
.project-list__card {
  display: flex;
  gap: 12px;
  padding: 20px 16px;
  background: #fff;
  border: 1px solid var(--fg-line, #dbdbdb);
  border-radius: 12px;
  transition: var(--transition-fast, all 0.15s ease);
}

.project-list__card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.project-list__card--selected {
  border-color: var(--fg-text-basic, #3b3b3b);
}

.project-list__card-check {
  flex-shrink: 0;
  padding-top: 6px;
}

.project-list__card-body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.project-list__card-head {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.project-list__card-title-wrap {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-top: 4px;
}

.project-list__card-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
  color: var(--fg-text-basic, #3b3b3b);
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.project-list__card-title:hover {
  color: var(--fg-button-hover, #7362c2);
}

.project-list__card-date {
  margin: 0;
  font-size: 12px;
  color: var(--fg-text-gray, #838383);
}

.project-list__card-summary {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: var(--fg-text-basic, #3b3b3b);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.project-list__card-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  margin-top: auto;
}

.project-list__icon-btn {
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: var(--fg-text-gray, #838383);
  cursor: pointer;
  transition: var(--transition-fast, all 0.15s ease);
}

.project-list__icon-btn:hover {
  background: rgba(0, 0, 0, 0.04);
  color: var(--fg-text-basic, #3b3b3b);
}

.project-list__icon-btn--danger:hover {
  color: var(--danger-500, #ef4444);
}

/* ───────── ProjectDetail — 컨텐츠 영역 ───────── */
.prompt__content.project-detail__content {
  width: 100%;
  max-width: 820px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-top: 28px;
}

.project-detail__head {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 8px 0 16px;
  border-bottom: 1px solid var(--fg-line, #dbdbdb);
}

.project-detail__header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.project-detail__header-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.project-detail__menu-btn {
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: var(--fg-text-basic, #3b3b3b);
  cursor: pointer;
}

.project-detail__menu-btn:hover {
  background: rgba(0, 0, 0, 0.04);
}

.project-detail__title-wrap {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.project-detail__title {
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  color: var(--fg-text-basic, #3b3b3b);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.project-detail__desc {
  display: block;
  width: 100%;
  margin: 0;
  padding: 2px 6px;
  background: transparent;
  border: 0;
  border-radius: 6px;
  font-family: inherit;
  font-size: 14px;
  line-height: 22px;
  color: var(--fg-text-basic, #3b3b3b);
  text-align: left;
  cursor: pointer;
  white-space: normal;
  word-break: break-word;
  transition: var(--transition-fast);
}

.project-detail__desc:hover,
.project-detail__desc:focus-visible {
  background: rgba(0, 0, 0, 0.04);
  color: var(--fg-text-basic, #3b3b3b);
  outline: none;
}

.project-detail__desc--placeholder {
  color: var(--fg-text-gray, #838383);
  font-style: italic;
  opacity: 0.7;
}

.project-detail__desc-input {
  width: 100%;
  padding: 6px 8px;
  background: #fff;
  border: 1px solid var(--fg-line, #dbdbdb);
  border-radius: 8px;
  font-family: inherit;
  font-size: 14px;
  line-height: 22px;
  color: var(--fg-text-basic, #3b3b3b);
  outline: none;
  resize: vertical;
  min-height: 48px;
  transition: var(--transition-fast);
}

.project-detail__desc-input:focus {
  border-color: var(--fg-button);
  box-shadow: 0 0 0 3px rgba(86, 60, 240, 0.12);
}

.project-detail__desc-input:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.project-detail__title-btn {
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: var(--fg-text-gray, #838383);
  cursor: pointer;
}

.project-detail__title-btn:hover {
  background: rgba(0, 0, 0, 0.04);
  color: var(--fg-text-basic, #3b3b3b);
}

.project-detail__title-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.project-detail__title-btn--danger:hover {
  background: var(--error-light, #fdecec);
  color: var(--error, #ef4444);
}

.project-detail__title-input {
  flex: 1 1;
  margin: 0;
  padding: 4px 8px;
  font-size: 22px;
  font-weight: 600;
  font-family: inherit;
  color: var(--fg-text-basic, #3b3b3b);
  background: transparent;
  border: 1px solid var(--border-default, #d8d8d8);
  border-radius: 8px;
  outline: none;
}

.project-detail__title-input:focus {
  border-color: var(--primary-500, #7c5cff);
}

.project-detail__chat-empty {
  list-style: none;
  padding: 24px 0;
  color: var(--fg-text-gray, #838383);
  font-size: 14px;
  text-align: center;
}

/* 입력박스 영역 */
.project-detail__input-area {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.project-detail__input-area .llm__input-box {
  width: 100%;
}

.project-detail__input-hint {
  margin: 0 4px 0;
  font-size: 12px;
  color: var(--fg-text-gray, #838383);
}

/* 대화 목록 */
.project-detail__chat-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.project-detail__chat-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 18px;
  background: #fff;
  border: 1px solid var(--fg-line, #dbdbdb);
  border-radius: 12px;
  cursor: pointer;
  transition: var(--transition-fast, all 0.15s ease);
}

.project-detail__chat-item:hover {
  border-color: var(--fg-text-gray, #838383);
  box-shadow: var(--shadow-sm, 0 1px 2px rgba(0, 0, 0, 0.05));
}

.project-detail__chat-icon {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  border-radius: var(--radius-full, 9999px);
}

.project-detail__chat-item--agent .project-detail__chat-icon {
  color: var(--fg-text-purple, #7362c2);
  background: var(--fg-bg-litepp, #e8eaf5);
}

.project-detail__chat-item--chat .project-detail__chat-icon {
  color: var(--fg-emr-green, #82d3d5);
  background: var(--fg-bg-cool, #f2ffff);
}

.project-detail__chat-body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.project-detail__chat-eyebrow {
  margin: 0;
  font-size: 12px;
  font-weight: 500;
  color: var(--fg-text-gray, #838383);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.project-detail__chat-item--agent .project-detail__chat-eyebrow {
  color: var(--fg-text-purple, #7362c2);
}

.project-detail__chat-item--chat .project-detail__chat-eyebrow {
  color: var(--fg-emr-green, #82d3d5);
}

.project-detail__chat-title {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: #464646;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.project-detail__chat-meta {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  min-height: 28px;
}

.project-detail__chat-time {
  font-size: 12px;
  color: var(--fg-text-gray, #838383);
  white-space: nowrap;
}

.project-detail__chat-actions {
  display: none;
  align-items: center;
  gap: 2px;
}

/* 마우스 호버 시에만: 시간 숨기고 액션 노출 */
.project-detail__chat-item:hover .project-detail__chat-time {
  display: none;
}

.project-detail__chat-item:hover .project-detail__chat-actions {
  display: inline-flex;
}

.project-detail__chat-btn {
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: var(--fg-text-gray, #838383);
  cursor: pointer;
  transition: var(--transition-fast, all 0.15s ease);
}

.project-detail__chat-btn:hover {
  background: rgba(0, 0, 0, 0.06);
  color: var(--fg-text-basic, #3b3b3b);
}

.project-detail__chat-btn--danger {
  color: var(--fg-orange-warn, #ff7700);
}

.project-detail__chat-btn--danger:hover {
  background: var(--fg-bg-warning, #fff3e8);
  color: var(--fg-orange-warn, #ff7700);
}

/* ========================================================================
   모바일 (≤720px) — 프로젝트 (List / Detail).
   사이드바(프로젝트 목록 + 대화 목록)는 AI채팅(LlmChat) 패턴: 기본 접힘(레일),
   펼치면 오버레이 드로어. 공유 셸을 쓰므로 .project-page 로 스코프해 타 기능 영향 차단.
   ======================================================================== */
@media (max-width: 720px) {
  /* 카드 셸 여백 제거 — 폭 확보 (AI채팅 .llm__layout 과 동일) */
  .project-page .prompt__layout {
    margin: 0;
    border-radius: 0;
  }

  /* 펼친 사이드바 = 화면 위로 덮는 오버레이 드로어 (+ 큰 spread 그림자로 스크림) */
  .project-page .prompt__sidebar {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    width: 84vw;
    max-width: 320px;
    z-index: 200;
    box-shadow: 0 0 0 100vw rgba(14, 27, 43, 0.4), 8px 0 24px rgba(0, 0, 0, 0.18);
  }

  /* 접힘 = AI채팅과 동일: 레일을 띄우지 않고 좌상단 플로팅 토글 버튼만 노출.
     본문이 풀폭을 쓰도록 사이드바를 흐름 밖(fixed)으로 빼고 나머지 아이콘은 숨긴다. */
  .project-page .prompt__sidebar--collapsed {
    position: fixed;
    top: 60px;
    left: 12px;
    bottom: auto;
    width: auto;
    padding: 0;
    gap: 0;
    background: transparent;
    box-shadow: none;
    z-index: 60;
  }

  .project-page .prompt__sidebar--collapsed .prompt__sidebar-collapsed-nav {
    display: none;
  }

  /* 토글 = AI채팅 .llm-chat__mobile-menu 스타일(흰 버튼 + 그림자) */
  .project-page .prompt__sidebar--collapsed .prompt__sidebar-mini-btn--toggle {
    width: 40px;
    height: 40px;
    border-radius: 12px;
    background: #fff;
    border: 1px solid var(--fg-line);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
    color: var(--fg-text-basic);
  }

  .project-page .prompt__content {
    padding: 16px 14px;
    gap: 24px;
  }

  /* 플로팅 토글 버튼(좌상단)과 겹치지 않게 제목 줄을 들여써 'menu 제목'처럼 정렬 */
  .project-page .prompt-intro__heading {
    min-height: 40px;
    padding-left: 48px;
  }

  .project-page .prompt-intro__h1 {
    font-size: 22px;
    line-height: 32px;
  }

  /* ProjectList — 카드 1열(그리드/리스트 공통) + 툴바 정리 */
  .project-page .project-list__cards--grid,
  .project-page .project-list__cards--list {
    grid-template-columns: minmax(0, 1fr);
    gap: 12px;
  }

  .project-page .prompt-list__filter-right {
    width: 100%;
    flex-wrap: wrap;
  }

  .project-page .prompt-list__search {
    flex: 1 1;
    width: auto;
    min-width: 0;
  }

  .project-page .prompt-list__view-toggle {
    display: none;
  }

  /* ProjectDetail — 채팅 칼럼 풀폭 사용 + 플로팅 토글과 안 겹치게 헤더 들여쓰기 */
  .project-page .project-detail__content {
    padding: 16px 14px 28px;
  }

  .project-page .project-detail__header {
    padding-left: 48px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/Project.css"],"names":[],"mappings":"AAAA;;;6EAG6E;;AAE7E,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,wCAAwC;EACxC,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA,sDAAsD;;AAEtD,gDAAgD;AAChD;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;AAEA,iDAAiD;AACjD;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oCAAoC;EACpC,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,+CAA+C;AAC/C;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;;EAEE,+BAA+B;EAC/B,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,oCAAoC;EACpC,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,oCAAoC;EACpC,uBAAuB;EACvB,gDAAgD;EAChD,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mCAAmC;EACnC,eAAe;EACf,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;EACf,mCAAmC;AACrC;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,0CAA0C;EAC1C,2DAA2D;AAC7D;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,6BAA6B;AAC7B;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;;;;6EAI6E;AAC7E;EACE,+CAA+C;EAC/C;IACE,SAAS;IACT,gBAAgB;EAClB;;EAEA,sDAAsD;EACtD;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,6EAA6E;EAC/E;;EAEA;uDACqD;EACrD;IACE,eAAe;IACf,SAAS;IACT,UAAU;IACV,YAAY;IACZ,WAAW;IACX,UAAU;IACV,MAAM;IACN,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA,qDAAqD;EACrD;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,gCAAgC;IAChC,yCAAyC;IACzC,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA,oDAAoD;EACpD;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA,4CAA4C;EAC5C;;IAEE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,SAAO;IACP,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA,wDAAwD;EACxD;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* ========================================================================\n   Project — 프로젝트 영역\n   사이드바·인트로·필터 공통 스타일은 Prompt.css / Agent.css 재사용\n   ======================================================================== */\n\n/* ───────── 사이드바 ───────── */\n.project__sidebar {\n  display: flex;\n  flex-direction: column;\n}\n\n.project__sidebar-new {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 10px 12px;\n  background: var(--fg-bg-mychat, #e5e7f3);\n  border: 0;\n  border-radius: 12px;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--fg-text-basic, #3b3b3b);\n  cursor: pointer;\n  text-align: left;\n  transition: var(--transition-fast, all 0.15s ease);\n}\n\n.project__sidebar-new:hover {\n  background: var(--fg-bg-liteblue, #f6f8ff);\n}\n\n.project__sidebar-new > svg {\n  flex-shrink: 0;\n  color: var(--fg-text-basic, #3b3b3b);\n}\n\n.project__sidebar-projects {\n  list-style: none;\n  margin: 8px 0 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.project__sidebar-project {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 10px 10px 14px;\n  background: #fff;\n  border: 1px solid #fff;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: var(--transition-fast, all 0.15s ease);\n}\n\n.project__sidebar-project:hover {\n  background: #fff7f0;\n  border-color: #ffcfa8;\n}\n\n.project__sidebar-project--active,\n.project__sidebar-project--active:hover {\n  background: #fff7f0;\n  border-color: #ff7700;\n}\n\n.project__sidebar-project-icon {\n  flex-shrink: 0;\n  width: 28px;\n  height: 28px;\n  display: grid;\n  place-items: center;\n  color: #ff7700;\n}\n\n.project__sidebar-project-title {\n  flex: 1;\n  min-width: 0;\n  padding-top: 4px;\n  font-size: 15px;\n  font-weight: 500;\n  color: #464646;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.project__sidebar-project-actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n}\n\n.project__sidebar-project-btn {\n  width: 28px;\n  height: 28px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 6px;\n  color: var(--fg-text-gray, #838383);\n  cursor: pointer;\n}\n\n.project__sidebar-project-btn:hover {\n  background: rgba(0, 0, 0, 0.04);\n  color: var(--fg-text-basic, #3b3b3b);\n}\n\n/* 사이드바 대화 항목은 LLM 실습 사이드바(.llm__chat-*) 디자인을 그대로 사용 */\n\n/* ───────── ProjectList — 생성하기 버튼 행 ───────── */\n.project-list__create-row {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 8px;\n  margin-bottom: 12px;\n}\n\n/* ───────── ProjectList — 카드 그리드/리스트 ───────── */\n.project-list__cards {\n  margin-top: 16px;\n  display: grid;\n  gap: 16px;\n}\n\n.project-list__cards--grid {\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\n.project-list__cards--list {\n  grid-template-columns: 1fr;\n}\n\n@media (max-width: 1280px) {\n  .project-list__cards--grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n/* ───────── 프로젝트 카드 ───────── */\n.project-list__card {\n  display: flex;\n  gap: 12px;\n  padding: 20px 16px;\n  background: #fff;\n  border: 1px solid var(--fg-line, #dbdbdb);\n  border-radius: 12px;\n  transition: var(--transition-fast, all 0.15s ease);\n}\n\n.project-list__card:hover {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.project-list__card--selected {\n  border-color: var(--fg-text-basic, #3b3b3b);\n}\n\n.project-list__card-check {\n  flex-shrink: 0;\n  padding-top: 6px;\n}\n\n.project-list__card-body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.project-list__card-head {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n}\n\n.project-list__card-title-wrap {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding-top: 4px;\n}\n\n.project-list__card-title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.4;\n  color: var(--fg-text-basic, #3b3b3b);\n  cursor: pointer;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.project-list__card-title:hover {\n  color: var(--fg-button-hover, #7362c2);\n}\n\n.project-list__card-date {\n  margin: 0;\n  font-size: 12px;\n  color: var(--fg-text-gray, #838383);\n}\n\n.project-list__card-summary {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.5;\n  color: var(--fg-text-basic, #3b3b3b);\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.project-list__card-footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 4px;\n  margin-top: auto;\n}\n\n.project-list__icon-btn {\n  width: 28px;\n  height: 28px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: var(--fg-text-gray, #838383);\n  cursor: pointer;\n  transition: var(--transition-fast, all 0.15s ease);\n}\n\n.project-list__icon-btn:hover {\n  background: rgba(0, 0, 0, 0.04);\n  color: var(--fg-text-basic, #3b3b3b);\n}\n\n.project-list__icon-btn--danger:hover {\n  color: var(--danger-500, #ef4444);\n}\n\n/* ───────── ProjectDetail — 컨텐츠 영역 ───────── */\n.prompt__content.project-detail__content {\n  width: 100%;\n  max-width: 820px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  padding-top: 28px;\n}\n\n.project-detail__head {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 8px 0 16px;\n  border-bottom: 1px solid var(--fg-line, #dbdbdb);\n}\n\n.project-detail__header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.project-detail__header-actions {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n}\n\n.project-detail__menu-btn {\n  width: 32px;\n  height: 32px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: var(--fg-text-basic, #3b3b3b);\n  cursor: pointer;\n}\n\n.project-detail__menu-btn:hover {\n  background: rgba(0, 0, 0, 0.04);\n}\n\n.project-detail__title-wrap {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.project-detail__title {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 600;\n  color: var(--fg-text-basic, #3b3b3b);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.project-detail__desc {\n  display: block;\n  width: 100%;\n  margin: 0;\n  padding: 2px 6px;\n  background: transparent;\n  border: 0;\n  border-radius: 6px;\n  font-family: inherit;\n  font-size: 14px;\n  line-height: 22px;\n  color: var(--fg-text-basic, #3b3b3b);\n  text-align: left;\n  cursor: pointer;\n  white-space: normal;\n  word-break: break-word;\n  transition: var(--transition-fast);\n}\n\n.project-detail__desc:hover,\n.project-detail__desc:focus-visible {\n  background: rgba(0, 0, 0, 0.04);\n  color: var(--fg-text-basic, #3b3b3b);\n  outline: none;\n}\n\n.project-detail__desc--placeholder {\n  color: var(--fg-text-gray, #838383);\n  font-style: italic;\n  opacity: 0.7;\n}\n\n.project-detail__desc-input {\n  width: 100%;\n  padding: 6px 8px;\n  background: #fff;\n  border: 1px solid var(--fg-line, #dbdbdb);\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 14px;\n  line-height: 22px;\n  color: var(--fg-text-basic, #3b3b3b);\n  outline: none;\n  resize: vertical;\n  min-height: 48px;\n  transition: var(--transition-fast);\n}\n\n.project-detail__desc-input:focus {\n  border-color: var(--fg-button);\n  box-shadow: 0 0 0 3px rgba(86, 60, 240, 0.12);\n}\n\n.project-detail__desc-input:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.project-detail__title-btn {\n  width: 28px;\n  height: 28px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: var(--fg-text-gray, #838383);\n  cursor: pointer;\n}\n\n.project-detail__title-btn:hover {\n  background: rgba(0, 0, 0, 0.04);\n  color: var(--fg-text-basic, #3b3b3b);\n}\n\n.project-detail__title-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.project-detail__title-btn--danger:hover {\n  background: var(--error-light, #fdecec);\n  color: var(--error, #ef4444);\n}\n\n.project-detail__title-input {\n  flex: 1;\n  margin: 0;\n  padding: 4px 8px;\n  font-size: 22px;\n  font-weight: 600;\n  font-family: inherit;\n  color: var(--fg-text-basic, #3b3b3b);\n  background: transparent;\n  border: 1px solid var(--border-default, #d8d8d8);\n  border-radius: 8px;\n  outline: none;\n}\n\n.project-detail__title-input:focus {\n  border-color: var(--primary-500, #7c5cff);\n}\n\n.project-detail__chat-empty {\n  list-style: none;\n  padding: 24px 0;\n  color: var(--fg-text-gray, #838383);\n  font-size: 14px;\n  text-align: center;\n}\n\n/* 입력박스 영역 */\n.project-detail__input-area {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.project-detail__input-area .llm__input-box {\n  width: 100%;\n}\n\n.project-detail__input-hint {\n  margin: 0 4px 0;\n  font-size: 12px;\n  color: var(--fg-text-gray, #838383);\n}\n\n/* 대화 목록 */\n.project-detail__chat-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.project-detail__chat-item {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 12px 18px;\n  background: #fff;\n  border: 1px solid var(--fg-line, #dbdbdb);\n  border-radius: 12px;\n  cursor: pointer;\n  transition: var(--transition-fast, all 0.15s ease);\n}\n\n.project-detail__chat-item:hover {\n  border-color: var(--fg-text-gray, #838383);\n  box-shadow: var(--shadow-sm, 0 1px 2px rgba(0, 0, 0, 0.05));\n}\n\n.project-detail__chat-icon {\n  flex-shrink: 0;\n  width: 36px;\n  height: 36px;\n  display: grid;\n  place-items: center;\n  border-radius: var(--radius-full, 9999px);\n}\n\n.project-detail__chat-item--agent .project-detail__chat-icon {\n  color: var(--fg-text-purple, #7362c2);\n  background: var(--fg-bg-litepp, #e8eaf5);\n}\n\n.project-detail__chat-item--chat .project-detail__chat-icon {\n  color: var(--fg-emr-green, #82d3d5);\n  background: var(--fg-bg-cool, #f2ffff);\n}\n\n.project-detail__chat-body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.project-detail__chat-eyebrow {\n  margin: 0;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--fg-text-gray, #838383);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.project-detail__chat-item--agent .project-detail__chat-eyebrow {\n  color: var(--fg-text-purple, #7362c2);\n}\n\n.project-detail__chat-item--chat .project-detail__chat-eyebrow {\n  color: var(--fg-emr-green, #82d3d5);\n}\n\n.project-detail__chat-title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: #464646;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.project-detail__chat-meta {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  min-height: 28px;\n}\n\n.project-detail__chat-time {\n  font-size: 12px;\n  color: var(--fg-text-gray, #838383);\n  white-space: nowrap;\n}\n\n.project-detail__chat-actions {\n  display: none;\n  align-items: center;\n  gap: 2px;\n}\n\n/* 마우스 호버 시에만: 시간 숨기고 액션 노출 */\n.project-detail__chat-item:hover .project-detail__chat-time {\n  display: none;\n}\n\n.project-detail__chat-item:hover .project-detail__chat-actions {\n  display: inline-flex;\n}\n\n.project-detail__chat-btn {\n  width: 28px;\n  height: 28px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: var(--fg-text-gray, #838383);\n  cursor: pointer;\n  transition: var(--transition-fast, all 0.15s ease);\n}\n\n.project-detail__chat-btn:hover {\n  background: rgba(0, 0, 0, 0.06);\n  color: var(--fg-text-basic, #3b3b3b);\n}\n\n.project-detail__chat-btn--danger {\n  color: var(--fg-orange-warn, #ff7700);\n}\n\n.project-detail__chat-btn--danger:hover {\n  background: var(--fg-bg-warning, #fff3e8);\n  color: var(--fg-orange-warn, #ff7700);\n}\n\n/* ========================================================================\n   모바일 (≤720px) — 프로젝트 (List / Detail).\n   사이드바(프로젝트 목록 + 대화 목록)는 AI채팅(LlmChat) 패턴: 기본 접힘(레일),\n   펼치면 오버레이 드로어. 공유 셸을 쓰므로 .project-page 로 스코프해 타 기능 영향 차단.\n   ======================================================================== */\n@media (max-width: 720px) {\n  /* 카드 셸 여백 제거 — 폭 확보 (AI채팅 .llm__layout 과 동일) */\n  .project-page .prompt__layout {\n    margin: 0;\n    border-radius: 0;\n  }\n\n  /* 펼친 사이드바 = 화면 위로 덮는 오버레이 드로어 (+ 큰 spread 그림자로 스크림) */\n  .project-page .prompt__sidebar {\n    position: fixed;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    width: 84vw;\n    max-width: 320px;\n    z-index: 200;\n    box-shadow: 0 0 0 100vw rgba(14, 27, 43, 0.4), 8px 0 24px rgba(0, 0, 0, 0.18);\n  }\n\n  /* 접힘 = AI채팅과 동일: 레일을 띄우지 않고 좌상단 플로팅 토글 버튼만 노출.\n     본문이 풀폭을 쓰도록 사이드바를 흐름 밖(fixed)으로 빼고 나머지 아이콘은 숨긴다. */\n  .project-page .prompt__sidebar--collapsed {\n    position: fixed;\n    top: 60px;\n    left: 12px;\n    bottom: auto;\n    width: auto;\n    padding: 0;\n    gap: 0;\n    background: transparent;\n    box-shadow: none;\n    z-index: 60;\n  }\n\n  .project-page .prompt__sidebar--collapsed .prompt__sidebar-collapsed-nav {\n    display: none;\n  }\n\n  /* 토글 = AI채팅 .llm-chat__mobile-menu 스타일(흰 버튼 + 그림자) */\n  .project-page .prompt__sidebar--collapsed .prompt__sidebar-mini-btn--toggle {\n    width: 40px;\n    height: 40px;\n    border-radius: 12px;\n    background: #fff;\n    border: 1px solid var(--fg-line);\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);\n    color: var(--fg-text-basic);\n  }\n\n  .project-page .prompt__content {\n    padding: 16px 14px;\n    gap: 24px;\n  }\n\n  /* 플로팅 토글 버튼(좌상단)과 겹치지 않게 제목 줄을 들여써 'menu 제목'처럼 정렬 */\n  .project-page .prompt-intro__heading {\n    min-height: 40px;\n    padding-left: 48px;\n  }\n\n  .project-page .prompt-intro__h1 {\n    font-size: 22px;\n    line-height: 32px;\n  }\n\n  /* ProjectList — 카드 1열(그리드/리스트 공통) + 툴바 정리 */\n  .project-page .project-list__cards--grid,\n  .project-page .project-list__cards--list {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 12px;\n  }\n\n  .project-page .prompt-list__filter-right {\n    width: 100%;\n    flex-wrap: wrap;\n  }\n\n  .project-page .prompt-list__search {\n    flex: 1;\n    width: auto;\n    min-width: 0;\n  }\n\n  .project-page .prompt-list__view-toggle {\n    display: none;\n  }\n\n  /* ProjectDetail — 채팅 칼럼 풀폭 사용 + 플로팅 토글과 안 겹치게 헤더 들여쓰기 */\n  .project-page .project-detail__content {\n    padding: 16px 14px 28px;\n  }\n\n  .project-page .project-detail__header {\n    padding-left: 48px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
